<label class="data-label" *ngIf="inputLabel" [ngClass]="labelClass">{{
  inputLabel
}}</label>

<div class="password-wrap">
  <input
    [type]="passwordVisible ? 'text' : 'password'"
    [style]="inputClass"
    [placeholder]="inputPlaceholder"
    [ngClass]="
      fControl && fControl.invalid && fControl.touched ? 'is-invalid' : ''
    "
    *ngIf="fControl"
    [formControl]="fControl"
    [required]="true"
    class="form-control password-input"
    (blur)="sendData()"
    (click)="onClick($event)"
    (keydown.enter)="$event.preventDefault()"
  />
  <button class="btn btn-eye" (click)="togglePasswordVisibility()" tabindex="-1">
    <img
      *ngIf="passwordVisible"
      src="../assets/images/ic-eye-open.svg"
      alt="Icon"
    />
    <img
      *ngIf="!passwordVisible"
      src="../assets/images/ic-eye-close.svg"
      alt="Icon"
    />
  </button>
</div>

<div *ngIf="fControl && fControl.invalid && fControl.touched">
  <div
    [ngClass]="fControl && fControl.invalid ? 'invalid-feedback d-block' : ''"
    *ngIf="fControl.errors.required"
  >
    Please enter {{ inputLabel | lowercase }}
  </div>
  <div
    [ngClass]="fControl && fControl.invalid ? 'invalid-feedback d-block' : ''"
    *ngIf="fControl.errors.pattern && patternValidationMsg"
  >
    {{ patternValidationMsg }}
  </div>
  <div
    [ngClass]="fControl && fControl.invalid ? 'invalid-feedback d-block' : ''"
    *ngIf="fControl.errors.maxlength && maxLengthValidationMsg"
  >
    {{ maxLengthValidationMsg }}
  </div>
  <div
  [ngClass]="fControl && fControl.invalid ? 'invalid-feedback d-block' : ''"
  *ngIf="fControl.errors.minlength && minLengthValidationMsg"
>
  {{ minLengthValidationMsg }}
</div>
  <div
    [ngClass]="fControl && fControl.invalid ? 'invalid-feedback d-block' : ''"
    *ngIf="fControl.errors.CustomError && customErrorValidationMsg"
  >
    {{ customErrorValidationMsg }}
  </div>
</div>
